import { EventEmitter } from '@angular/core';
import { FidelityIntegrationService } from 'IntegrationsApp/ts/services/fidelity-integration.service';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/fidelity-integration.service";
import * as i2 from "@angular/common";
import * as i3 from "@angular/forms";
import * as i4 from "../../../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i5 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i7 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function FidelityIntegrationActivateModalComponent_ycn_loading_symbol_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 7);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Activating...");
} }
function FidelityIntegrationActivateModalComponent_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 19);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r1.errorMessage);
} }
function FidelityIntegrationActivateModalComponent_div_4_div_16_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 23);
    i0.ɵɵlistener("click", function FidelityIntegrationActivateModalComponent_div_4_div_16_span_2_Template_span_click_2_listener() { const i_r4 = i0.ɵɵrestoreView(_r3).index; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.removeHeader(i_r4)); });
    i0.ɵɵtext(3, "\u00D7");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const header_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", header_r5, " ");
} }
function FidelityIntegrationActivateModalComponent_div_4_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 20);
    i0.ɵɵtemplate(2, FidelityIntegrationActivateModalComponent_div_4_div_16_span_2_Template, 4, 1, "span", 21);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.headers);
} }
function FidelityIntegrationActivateModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "div", 10);
    i0.ɵɵtemplate(3, FidelityIntegrationActivateModalComponent_div_4_div_3_Template, 1, 1, "div", 11);
    i0.ɵɵelementStart(4, "div", 12)(5, "b");
    i0.ɵɵtext(6, "Enter your headers to activate the Fidelity integration:");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "form", 13)(8, "div", 12)(9, "div", 14);
    i0.ɵɵtext(10, "Header:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 15)(12, "input", 16, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function FidelityIntegrationActivateModalComponent_div_4_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.headerInput, $event) || (ctx_r1.headerInput = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("keyup.enter", function FidelityIntegrationActivateModalComponent_div_4_Template_input_keyup_enter_12_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.addHeader()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "button", 17);
    i0.ɵɵlistener("click", function FidelityIntegrationActivateModalComponent_div_4_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.addHeader()); });
    i0.ɵɵtext(15, "Add");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(16, FidelityIntegrationActivateModalComponent_div_4_div_16_Template, 3, 1, "div", 18);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessage !== "");
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("placeholder", "Enter header");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.headerInput);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.headers.length > 0);
} }
export class FidelityIntegrationActivateModalComponent {
    openModal(existingHeaders = []) {
        this.headers = [...existingHeaders];
        this.headerInput = '';
        this.errorMessage = '';
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
        this.errorMessage = '';
        this.closeModalHandler.emit();
    }
    constructor(fidelityIntegrationService) {
        this.fidelityIntegrationService = fidelityIntegrationService;
        this.closeModalHandler = new EventEmitter();
        this.modalOpen = false;
        this.errorMessage = '';
        this.loading = false;
        this.headers = [];
        this.headerInput = '';
    }
    addHeader() {
        const value = this.headerInput.trim();
        if (!value) {
            return;
        }
        if (this.headers.includes(value)) {
            return;
        }
        this.headers.push(value);
        this.headerInput = '';
    }
    removeHeader(index) {
        this.headers.splice(index, 1);
    }
    canSubmit() {
        return !this.loading && this.headers.length > 0;
    }
    onSubmit() {
        this.loading = true;
        this.errorMessage = '';
        this.fidelityIntegrationService.activateFidelityIntegration({ headers: this.headers }).subscribe({
            next: () => {
                this.loading = false;
                this.closeModal();
                window.location.reload();
            },
            error: (err) => {
                this.loading = false;
                this.errorMessage = err.error.errorMessage;
            },
        });
    }
}
FidelityIntegrationActivateModalComponent.ɵfac = function FidelityIntegrationActivateModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FidelityIntegrationActivateModalComponent)(i0.ɵɵdirectiveInject(i1.FidelityIntegrationService)); };
FidelityIntegrationActivateModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FidelityIntegrationActivateModalComponent, selectors: [["ycn-fidelity-integration-activate-modal"]], outputs: { closeModalHandler: "closeModalHandler" }, standalone: false, decls: 6, vars: 7, consts: [["headerInputEl", ""], [3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [3, "loaderMessage", 4, "ngIf"], ["class", "modal-section", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "submitButtonText", "disableSubmission"], [3, "loaderMessage"], [1, "modal-section"], [1, "row"], [1, "col"], ["class", "form-row text-red", 3, "textContent", 4, "ngIf"], [1, "form-row"], ["action", "javascript:void(0);"], [1, "form-label", "form-label-thin"], [1, "d-flex"], ["type", "text", "name", "headerInput", 1, "form-control", 3, "ngModelChange", "keyup.enter", "placeholder", "ngModel"], ["type", "button", 1, "btn", "btn-primary", "ml-2", 3, "click"], ["class", "form-row", 4, "ngIf"], [1, "form-row", "text-red", 3, "textContent"], [1, "d-flex", "flex-wrap"], ["class", "badge badge-secondary mr-1 mb-1", 4, "ngFor", "ngForOf"], [1, "badge", "badge-secondary", "mr-1", "mb-1"], [1, "ml-1", "cursor-pointer", 3, "click"]], template: function FidelityIntegrationActivateModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function FidelityIntegrationActivateModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function FidelityIntegrationActivateModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 3);
        i0.ɵɵtemplate(3, FidelityIntegrationActivateModalComponent_ycn_loading_symbol_3_Template, 1, 1, "ycn-loading-symbol", 4)(4, FidelityIntegrationActivateModalComponent_div_4_Template, 17, 4, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "ycn-simple-modal-footer", 6);
        i0.ɵɵlistener("cancelHandler", function FidelityIntegrationActivateModalComponent_Template_ycn_simple_modal_footer_cancelHandler_5_listener() { return ctx.closeModal(); })("submitHandler", function FidelityIntegrationActivateModalComponent_Template_ycn_simple_modal_footer_submitHandler_5_listener() { return ctx.onSubmit(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-dialog")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Activate Fidelity Integration");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("submitButtonText", "Activate")("disableSubmission", !ctx.canSubmit());
    } }, dependencies: [i2.NgForOf, i2.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.NgModel, i3.NgForm, i4.LoadingSymbolComponent, i5.ModalBaseComponent, i6.SimpleModalFooterComponent, i7.SimpleModalHeaderComponent], encapsulation: 2 });
